import { api } from '../core';

interface UpdateTimelineEntrySummaryResponse {
  success: boolean;
}

interface UpdateTimelineEntrySummaryProps {
  abortController?: AbortController;
  entryId: string;
  summary: string;
}

const timelineEntrySummaryUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateTimelineEntrySummary: builder.query<UpdateTimelineEntrySummaryResponse, UpdateTimelineEntrySummaryProps>({
      query: ({ abortController = new AbortController(), entryId, summary }: UpdateTimelineEntrySummaryProps) => ({
        url: 'timeline/entry/summary/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          summary: summary
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateTimelineEntrySummary in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateTimelineEntrySummaryQuery } = timelineEntrySummaryUpdateApi;
